export default __webpack_public_path__ + "static/og-5de99d839a1187f27121898a06948234.png";